import {
  UuIdDTO,
  CheckDTO,
  OnfidoTokenDTO,
  VideoSelfingLandingDTO,
} from '@app/landing-videoselfing/model/videoselfing-model';
import { VideoselfingApi } from './videoselfing-api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class VideoSelfingStore {
  constructor(private videoselfingApi: VideoselfingApi) {}

  private applicantId: OnfidoTokenDTO;
  private onfidoError: boolean = false;

  getOnfidoDate(uuId: UuIdDTO): Promise<OnfidoTokenDTO> {
    return new Promise<any>((resolve, reject) => {
      this.videoselfingApi
        .postGetOnfidoDate(uuId)
        .toPromise()
        .then(
          (data: OnfidoTokenDTO) => {
            data ? resolve(data) : reject(data);
          },
          (error) => reject(error)
        );
    });
  }

  getLanding(uuId: UuIdDTO) {
    return new Promise<any>((resolve, reject) => {
      this.videoselfingApi
        .postGetLanding(uuId)
        .toPromise()
        .then(
          (data: VideoSelfingLandingDTO) => {
            data ? resolve(data) : reject(data);
          },
          (error) => reject(error)
        );
    });
  }

  postCreateCheck(onfidoToken: OnfidoTokenDTO): Promise<CheckDTO> {
    return new Promise<any>((resolve, reject) => {
      this.videoselfingApi
        .postCreateCheck(onfidoToken)
        .toPromise()
        .then(
          (data: CheckDTO) => {
            console.log('DATA');
            console.log(data);
            data ? resolve(data) : reject(data);
          },
          (error) => reject(error)
        );
    });
  }

  postAcceptConsents(uuId: UuIdDTO): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.videoselfingApi.postAcceptConsents(uuId).subscribe(
        (data: string) => {
          console.log('DATA');
          console.log(data);
          resolve(data);
        },
        (error) => {
          console.error('ERROR');
          console.error(error);
          reject(error);
        }
      );
    });
  }

  getHistoricalOnfido(applicantId: string, landingProcess: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.videoselfingApi
        .postGetHistoricalOnfido(applicantId, landingProcess)
        .toPromise()
        .then(
          (data: any) => {
            console.log(data);
            data || data == 'OK' ? resolve(data) : reject(data);
          },
          (error: any) => reject(error)
        );
    });
  }

  public setApplicantId(onfidoToken: OnfidoTokenDTO): void {
    this.applicantId = onfidoToken;
  }

  public getApplicantId() {
    return this.applicantId;
  }

  public setOnfidoError(error: boolean): void {
    this.onfidoError = error;
  }

  public getOnfidoError() {
    return this.onfidoError;
  }
}
